import React from 'react';
import styled from 'styled-components';
import { Column } from 'rbx';
// import { toast } from 'react-toastify';
// import swal from 'sweetalert';

import SelectDayAndTime from './SelectDayAndTime';
import HoursModal from './HoursModal';
import WeeklyHours from './WeeklyHours';
import Toggle from './Toggle';

const Container = styled.div`
  padding: 0.15rem 1rem;
`;

const CustomSchedule = ({ setFieldValue, values }) => {
  const [isActiveModal, setIsActiveModal] = React.useState(false);

  return (
    <>
      <Container>
        <Column.Group>
          <Column size="6">
            {isActiveModal && (
              <HoursModal
                values={values}
                isActive={isActiveModal}
                onClose={() => {
                  setIsActiveModal(false);
                }}
                setValue={setFieldValue}
                loading={false}
                isSubmitting={false}
              />
            )}
            <Toggle
              checked={values.custom_deal_schedule}
              onToggle={() => {
                setFieldValue(
                  'custom_deal_schedule',
                  !values.custom_deal_schedule,
                );
              }}
            />
            <br />
            {!values.hasDealHours && (
              <SelectDayAndTime onClick={() => setIsActiveModal(true)} />
            )}
            {values.hasDealHours && values.hours && values.hours?.length !== 0 && (
              <WeeklyHours
                hours={values.hours}
                name="Deal Schedule"
                onClick={() => {
                  setIsActiveModal(true);
                }}
              />
            )}
          </Column>
        </Column.Group>
      </Container>
    </>
  );
};

export default CustomSchedule;
